import { EstimatedRangePricingFields, Matter, TaxStatus } from "@design-system";
import { FindLibraryMatters_findAllMatters } from "../graphql/__generated_types__/FindLibraryMatters";
import { FilterMatters_filteredMatters_matters } from "../graphql/types";

export type TaxStatusKey = keyof typeof TaxStatus;

export function isPriceRange(priceOptions: any): priceOptions is EstimatedRangePricingFields {
  if (
    !("suggested" in priceOptions) ||
    !(typeof priceOptions.suggested === "object") ||
    !("chosen" in priceOptions) ||
    !(typeof priceOptions.chosen === "object")
  ) {
    {
      return false;
    }
  }

  return true;
}

export const matterToPrismaUpdate = (matter: Matter) => {
  const update = {
    title: { set: matter.title },
    status: { set: matter.status },
    pricingType: { set: matter.pricingType },
    pricingLevel: { set: matter.pricingLevel },
    template: { set: matter.template },
    externalReference: { set: matter.externalReference },
    taxStatus: { set: matter.taxStatus },
    includeTasksInProposalOutput: { set: matter.includeTasksInProposalOutput },
  };

  return update;
};

const TaxStatusKeyByValue: Record<string, TaxStatusKey> = Object.freeze(
  Object.keys(TaxStatus).reduce((map: any, key: string) => {
    map[TaxStatus[key as TaxStatusKey]] = key;
    return map;
  }, {} as any)
);

export const doesMatterTaxStatusExcludeTax = (taxStatusRaw: TaxStatus): boolean => {
  if (taxStatusRaw != null) {
    const taxStatusKey = TaxStatusKeyByValue[taxStatusRaw];
    const taxStatus = TaxStatus[taxStatusKey];
    return taxStatus !== TaxStatus.None;
  }
  return false;
};

export const matterInArrayOfMatters = <
  T extends Matter | FilterMatters_filteredMatters_matters | FindLibraryMatters_findAllMatters
>(
  matters: T[],
  searchBy: Partial<Omit<T, "undefined">>
): boolean => {
  return matters
    .map((matter) => {
      const searchByKeys = Object.keys(searchBy) as (keyof typeof searchBy)[];
      return searchByKeys
        .map((searchKey) => {
          return matter[searchKey] === searchBy[searchKey];
        })
        .includes(true);
    })
    .includes(true);
};
